import React, { useEffect, useState } from 'react';

const Gallery = () => {
  const [gallery, setGallery] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getGallery = async () => {
    try {
      const response = await fetch("https://itces.in/admin/api/gallery.php");

      // if (!response.ok) {
      //   throw new Error('Failed to fetch gallery data');
      // }

      const data = await response.json();
      setGallery(data?.data);
      setIsLoading(false);
      console.log(data?.data)
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getGallery();
  }, []);

  return (
    <div className='otherpage'>
      <div className='container'>
        <div className="section-title mb-4 headline text-center">
          <span className="subtitle text-uppercase">ITC Gallery</span>
          <h2><span>Gallery</span></h2>
        </div>
      </div>
      <div className='gallerysection'>
        <div className='container'>
          <div className='row'>
            {isLoading ? (
              <>
                <div className='col-sm-4'><div className="animated-background"></div></div>
                <div className='col-sm-4'><div className="animated-background"></div></div>
                <div className='col-sm-4'><div className="animated-background"></div></div>
              </>
            ) : (
              gallery.map((ele, index) => (
                <div key={index} className='col-sm-4'>
                  <div className='gallerybox'>
                    <img src={`https://itces.in/admin/uploads/gallery/${ele.imageUrl}`} alt={ele?.title} title={ele?.title} />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gallery;